module.exports = __webpack_public_path__ + "img/Digrab_Carrousel_3.cc8a360c.png";